<template xmlns="http://www.w3.org/1999/html">
	<el-dialog :visible.sync="visible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" class="data-dialog" width="1200px">
		<span slot="title" class="dialog-title">
			<img src="@/assets/images/close.png" alt="" @click="visible = false" />
		</span>
		<button class="el-button down-btn menu-btn el-button--primary" @click="handlePdf()">下载</button>
		<div class="mrt-content" ref="pdfcontent">
			<h1>商品现场问题报告书（FPR）</h1>
			<div class="sub-title">
				<h3 class="mb5"></h3>
				<h3>报告书编号：{{ form.serialNumber }}</h3>
			</div>
			<table class="table-border_bottom">
				<tr>
					<th colspan="2">商品名称</th>
					<th>商品代号</th>
					<th>商品分类</th>
					<th colspan="2">使用机型</th>
					<th colspan="2">机号</th>
				</tr>
				<tr>
					<td colspan="2">{{ partsNames.join(",") }}</td>
					<td>{{ partsNumbers.join(",") }}</td>
					<td></td>
					<td colspan="2">{{ form.repairDeviceName }}</td>
					<td colspan="2">{{ form.repairDeviceNumber }}</td>
				</tr>
				<tr>
					<td colspan="3">用户名称（联系人名）</td>
					<td>购买日</td>
					<td>开始使用日</td>
					<td>问题发生日</td>
					<td>使用的张数</td>
				</tr>
				<tr>
					<td colspan="3">{{ form.partsClaimCustomer.userName }},{{ form.partsClaimCustomer.contactName }}</td>
					<td></td>
					<td>{{ form.partsClaimMaterial.startUseDate.replaceAll("-", "/") }}</td>
					<td>{{ form.partsClaimMaterial.issueDate.replaceAll("-", "/") }}</td>
					<td>{{ form.partsClaimMaterial.pagesUsed }}</td>
				</tr>
				<tr>
					<td colspan="4" style="text-align: left">用户地址：（必须填） {{ form.partsClaimCustomer.addressDetail }}</td>
					<td colspan="3" style="text-align: left">用户电话：（必须填） {{ form.partsClaimCustomer.userPhone }}</td>
				</tr>
			</table>
			<table></table>
			<table class="table-border_bottom">
				<tr>
					<td colspan="6" style="text-align: left">主题：</td>
				</tr>
				<tr class="tr-height-150">
					<td colspan="6" style="text-align: left; vertical-align: top">
						现象：（请写上你看到的实际现象）
						<br />
						{{ form.partsClaimMaterial.failureSymptom }}
					</td>
				</tr>
				<tr class="tr-height-150">
					<td colspan="6" style="text-align: left; vertical-align: top">
						措施：（请写上你亲手实践的对策）
						<br />
						{{ form.partsClaimMaterial.failureAction }}
					</td>
				</tr>
				<tr>
					<th>报告日期</th>
					<th colspan="2">用户单位盖印</th>
					<th colspan="2">维修单位盖印</th>
					<th>报告人签名</th>
				</tr>
				<tr>
					<td>{{ form.submitTime.substring(0, 10).replaceAll("-", "/") }}</td>
					<td colspan="2"></td>
					<td colspan="2">{{ form.applyOrgName }}</td>
					<td>{{ form.createUsrNamePhone ? form.createUsrNamePhone.split("/")[0] : "" }}</td>
				</tr>
			</table>
			<table class="table-border_bottom">
				<tr>
					<th style="font-size: 18px; font-weight: bold">区域代理商或特约店填写</th>
				</tr>
				<tr class="tr-height-150">
					<template>
						<div style="text-align: center">
							<h2 class="mt10">上述情况属实，特此证明！</h2>
							<div class="mt30" style="display: flex; align-items: center; justify-content: center">
								<div style="display: flex; flex-direction: column" class="mr50">
									<p>区域代理商或特约店盖印</p>
									<span class="mt30" style="border-bottom: 2px solid black; width: 200px"></span>
								</div>
								<div style="display: flex; flex-direction: column" class="ml50">
									<p>区域代理商或特约店负责人签字</p>
									<span class="mt30" style="border-bottom: 2px solid black; width: 250px"></span>
								</div>
							</div>
						</div>
					</template>
				</tr>
			</table>
			<table class="table-border_bottom">
				<tr>
					<td colspan="5" style="text-align: left">区域代理商或特约店地址：{{ form.applyOrgName }}</td>
					<td style="text-align: left">邮编：</td>
				</tr>
			</table>
			<table>
				<tr>
					<td>请区域代理商或特约店附上进货发票复印件！</td>
				</tr>
				<td class="tr-height-200">
					<template>
						<div style="text-align: left; display: flex; flex-direction: column; width: 100%; height: 100%">
							<div style="flex-grow: 1">RCN技术支援课意见:</div>
							<div style="flex-grow: 12; text-align: center">{{ audit1.remark }}</div>
							<div style="flex-grow: 1; display: flex; justify-content: space-between">
								<span>审批人：{{ audit1.createName }}</span>
								<span>{{ audit1.createTime.substring(0, 10).replace(/(\d{4})-(\d{2})-(\d{2})/, "$1年$2月$3日") }}</span>
							</div>
						</div>
					</template>
				</td>
			</table>
			<div class="mt15" style="font-weight: bold">
				如经核实，陈述不实，RICOH将拒绝赔偿！
				<br />
				注意：赔偿件我们只发给区域代理商或特约店！
			</div>
		</div>
	</el-dialog>
</template>
<script>
import JsPDF from "jspdf";
import html2Canvas from "html2canvas";

export default {
	data() {
		return {
			visible: false,
			form: {
				createTime: "",
				createUsrNamePhone: "",
				createUsrCompany: "",
				submitTime: "",
				serialNumber: "",
				matertialType: "", //商品（耗材故障） 具体类型 1主机  2耗材 3选购件
				repairType: "3", // 索赔的类型 1、保修期内机器零件故障 2、理光单独订购零件 3、商品（耗材故障）
				applyOrgType: "", // 申请方信息-机构类型 1、网络店 2、特约维修店 3、代理商 4、分部
				applyOrgId: "", // 申请方信息 对应的机构id
				repairModelId: "", // 机型及开发名 一级
				repairDeviceId: "", // 机型及开发名 二级
				repairDeviceNumber: "", // 机号
				isSubmit: 0, // 是否提交 0否(表示暂存)  1是(提交索赔)
				repairDevices: [],
				//基本信息
				partsClaimMaterial: {
					startUseDate: "", // 开始使用日
					issueDate: "", // 问题发生日
					pagesUsed: "", // 使用张数
					failureSymptom: "", // 故障现象
					failureAction: "", // 故障措施
					additionalNotes: "", // 补充说明栏
					ricohOutboundFileIdList: [], //理光出库一览表 单上传文件的id
					ricohPurchaseFileIdList: [], //理光购货发票 上传文件的id
					faultyPartsFileIdList: [], //故障件照片和样张 上传文件的id
				},
				// 客户信息
				partsClaimCustomer: {
					// 省市县三级，提交时删除
					allAddress: [],
					userName: "", // 用户名
					contactName: "", // 联系人姓名
					userPhone: "", // 用户电话
					province: "", // 省
					city: "", // 市
					district: "", // 区县
					addressDetail: "", // 详细地址
				},
				// 机器零件信息
				partsDetailList: [],
			},
			audit1: {
				createTime: "",
				createName: "",
				remark: "",
			},
			partsNames: [],
			partsNumbers: [],
		};
	},
	methods: {
		init(data) {
			this.visible = true;
			this.$nextTick(() => {
				setTimeout(() => {
					this.form = data.form;
					console.log(this.form);
					let fillArray = data.partsDetailLists
						? JSON.parse(JSON.stringify(data.partsDetailLists))
						: JSON.parse(JSON.stringify(data.form.partsDetailList));
					for (const element of fillArray) {
						this.partsNames.push(element.partsName);
						this.partsNumbers.push(element.partsNumber);
					}
					if (this.form.hisAudit) {
						for (const element of this.form.hisAudit) {
							if (element.auditStatus == 43) {
								this.audit1 = element;
							}
						}
					}
					data.auditRemarks ? (this.audit1.remark = data.auditRemarks) : "";
				}, 50);
			});
		},
		// pdf下载
		handlePdf() {
			const title = "商品现场问题报告书（FPR）_" + new Date().getTime();
			const opts = {
				scale: window.devicePixelRatio * 3,
				dpi: window.devicePixelRatio * 4,
				allowTaint: true,
				useCORS: true,
			};
			let that = this;
			html2Canvas(this.$refs.pdfcontent, opts).then(function (canvas) {
				let imgWidth = 595.28;
				let imgHeight = 860;
				let pageData = canvas.toDataURL("image/jpeg", 1.0);
				let PDF = new JsPDF("", "pt", "a4");
				PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
				PDF.save(title + ".pdf");
				that.visible = false;
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.data-dialog /deep/ .el-dialog {
	border-radius: 10px !important;
}

.data-dialog /deep/ .el-dialog__body {
	padding: 0 20px !important;
}

.data-dialog .dialog-title {
	display: block;
	text-align: center;

	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}

	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}

.mrt-content {
	padding: 80px 60px;
	background-color: white;
	color: black;

	h1 {
		font-size: 28px;
		font-weight: normal;
		text-align: center;
		margin-bottom: 15px;
		color: black;
	}

	table {
		width: 100%;
		border-collapse: collapse;
		font-size: 16px;
		font-weight: normal;
		color: black;
		//margin-bottom: 15px;
	}

	.table-border {
		border: 1px solid black;
	}

	.table-border_bottom {
		border-top: 1px solid black;
		border-left: 1px solid black;
		border-right: 1px solid black;
		border-bottom: 2px double black;
	}

	th,
	td {
		border: 1.1px solid black;
	}

	th,
	td {
		font-weight: normal;
		padding: 6px;
		background-color: white;
		text-align: center;
		white-space: normal;
		word-wrap: break-word;
	}

	tr {
		height: 40px;
	}

	td {
		width: 150px;
	}

	.sub-title {
		display: flex;
		justify-content: space-between;
	}

	.tr-header_left {
		display: flex;
		justify-content: space-between;
		width: 100%;
		height: 100%;
		padding: 10px;
		box-sizing: border-box;

		.tr-header_left-span {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			text-align: left;
			flex: 0.6;

			.tr-header_left-span_type {
				display: flex;
				justify-content: space-between;

				.tr-header_left-span_type-sel {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					line-height: 26px;
				}
			}
		}

		.tr-header_rigth {
			width: 55%;
			min-height: 100%;
			line-height: 30px;
			color: red;
			font-weight: bolder;

			.tr-header_rigth-font {
				color: black;
				font-style: italic;
			}
		}
	}

	.tr-height-60 {
		height: 60px;
	}

	.tr-height-80 {
		height: 80px;
	}

	.tr-height-100 {
		height: 100px;
	}

	.tr-height-150 {
		height: 150px;
	}

	.tr-height-200 {
		height: 200px;
	}

	.th-title-left {
		text-align: left;
	}

	.th-title-left_top {
		text-align: left;
		vertical-align: top;
	}

	.td-text-center {
		text-align: center;
		vertical-align: center;
	}

	.th-inst {
		text-align: left;
		white-space: normal;
		word-wrap: break-word;
	}

	.opinion {
		display: flex;
		justify-content: space-between;

		.opinion-date {
			border-bottom: 1px solid black;
			border-right: 1px solid black;
			height: 30px;
			width: 100%;
			line-height: 30px;
			text-align: center;
		}
	}

	.opinion-top {
		height: 30px;
		width: 460px;
	}

	.opinion-bottom {
		width: 460px;
		height: 100px;
		position: absolute;
		right: 82px;
		bottom: 98px;
	}

	.tr_box {
		display: flex;
		justify-content: space-between;
		width: 100%;
		height: 200px;

		.tr_box-left {
			display: flex;
			flex-direction: column;
			width: 100%;
			height: 100%;
			box-sizing: border-box;
		}

		.tr_box-right {
			width: 460px;
			height: 100%;
			display: flex;
			align-items: flex-end;
		}

		.opinion-content {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 5px;
			box-sizing: border-box;
		}
	}

	.tr_box1 {
		display: flex;
		justify-content: space-between;
		width: 100%;
		height: 150px;

		.tr_box-left {
			display: flex;
			flex-direction: column;
			width: 100%;
			height: 100%;
			box-sizing: border-box;

			.tr_box-p {
				width: 100px;
				border-right: 1px solid black;
				border-bottom: 1px solid black;
				align-items: center;
				text-align: center;
			}
		}

		.tr_box-right {
			width: 800px;
			height: 100%;
			display: flex;
			align-items: flex-end;
		}

		.opinion-content {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 5px;
			box-sizing: border-box;
		}
	}

	.tr-notable-box {
		width: 100%;
		height: 200px;
		padding: 5px;
		display: flex;
		flex-direction: row;

		.box_1 {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			width: 120px;
			height: 100%;
		}
		.box_2 {
			width: 100%;
			text-align: left;
			margin-left: 15px;
		}
		.box_3 {
			width: 100%;
			text-align: left;
			margin-left: 0;
		}
	}
}
</style>
